import { useCallback, useEffect, useState } from "react";
import { previewClient } from "modules/Preview/client/previewClient";
import { Preview } from "modules/Preview/preview";

export const usePreviewSession = (surveyId: string) => {
  const [session, setSession] = useState<
    Preview.CreateSessionResponse | undefined
  >();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const createSession = useCallback(async () => {
    setIsLoading(true);
    setIsError(false);
    try {
      setSession(await previewClient.createPreviewSession(surveyId));
    } catch (e) {
      console.error(e);
      setSession(undefined);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [surveyId]);

  useEffect(() => {
    createSession();
  }, [createSession]);

  return { session, isLoading, isError, reset: createSession };
};
